<script>
  // core components
  import IndexNavbar from "components/Navbars/IndexNavbar.svelte";
  import Footer from "components/Footers/Footer.svelte";

  // function updateText() { 
  //   console.log("Updating text content...");
  //   const textItem =  document.getElementsByName("0-1/message")[0];

  //   const urlParams = new URLSearchParams(window.location.search);
  //   const build = urlParams.get('build');
  //   const selectederp = urlParams.get('erp');
  //   const selectedprocess = urlParams.get('process');
  //   const selecteddeploy = urlParams.get('deploy');
  //   const typ = urlParams.get('typ');
  //   let text = '';

  //   console.log(textItem)

  //   if (build == 'app') {
  //     text =  `Build:  Mobile App,\n Process: ${selectedprocess} \n Type: ${typ}`;  
  //   }
  //   if (build == 'agent') { 
  //     text =  `Build: AI Agent,\n ERP:  ${selectederp},\n Process: ${selectedprocess} \n Deployment: ${selecteddeploy}`;
  //   }
  //   console.log("Text to update:", text);
  //   if (textItem) {
  //     textItem.innerHTML = text;
  //     console.log("Text content updated:", textItem.value);
  //   }
    
  // }
  // window.setTimeout(function () { updateText(); }, 5000);

  // window.addEventListener("load", updateText);
</script>

<span><p>&nbsp;</p> </span><IndexNavbar />
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<p>&nbsp;</p>
<section class="relative block py-24 lg:pt-0 bg-blueGray-800">
  <div class="container mx-auto px-4">
    <div class="flex flex-wrap justify-center">
      <div class="w-full lg:w-6/12 px-4">
        <div
          class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-200"
        >
          <script
            src="https://js.hsforms.net/forms/embed/47300484.js"
            defer
          ></script>
          <div
            class="hs-form-frame"
            data-region="na1"
            data-form-id="5ade75eb-98bc-481f-a4c3-d67ff3342910"
            data-portal-id="47300484"
          ></div>
          {""}
        </div>
        <div
          class="relative flex flex-col min-w-0 break-words
          w-full -mt-48 sm:-mt-32 shadow-lg rounded-lg bg-blueGray-200"
        >&nbsp;</div>
      </div>
     
    </div>
  </div>
</section>
<Footer />



